import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { cloturerAnneeScolaire, getAnneeScolaire } from './annee-scolaire.reducer';

export const AnneeScolaireClotureModal = (props: RouteComponentProps<{ ecoleid: string; id: string }>) => {
  const { ecoleid, id } = props.match.params;
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getAnneeScolaire(id));
  }, []);

  const anneeScolaire = useAppSelector(state => state.anneeScolaire.entity);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/annee-scolaire/${ecoleid}`);
  };

  const confirmCloture = () => {
    const entity = {
      id: props.match.params.id,
      ecoleId: props.match.params.ecoleid,
    };
    dispatch(cloturerAnneeScolaire(entity));
    handleClose(event);
  };

  return (
    <Modal isOpen toggle={handleClose} centered size="small">
      <ModalHeader toggle={handleClose} data-cy="anneeScolaireClotureModalHeading">
        Confirmation de clôture d&apos;annee scolaire
      </ModalHeader>
      <ModalBody id="korischoolApp.annee-scolaire.cloture">
        <p>
          Vous êtes sur le point de <strong>clôturer l&apos;année scolaire &laquo;{anneeScolaire?.nom}&raquo;</strong>.
        </p>
        <p>Cette action aura les effets suivants :</p>
        <ul>
          <li>
            Tous les élèves associés seront automatiquement <strong>désinscrits</strong>.
          </li>
          <li>
            Il ne sera plus possible de <strong>créer de nouvelles factures</strong>, <strong>salaires</strong>, ni{' '}
            <strong>ajouter de nouvelles inscriptions</strong> dans cette année scolaire.
          </li>
          <li>
            Vous pourrez toujours <strong>consulter les historiques</strong> liés à cette année (inscriptions, paiements, pointages, etc.).
          </li>
          <li>
            L&apos;année scolaire sera <strong>archivée</strong> et passera au statut &laquo; clôturée &raquo;
          </li>
          <li>
            Cette opération est <strong>définitive et irréversible</strong>.
          </li>
        </ul>
        <p>Confirmez-vous la clôture {anneeScolaire?.nom} ?</p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button color="danger" onClick={confirmCloture}>
          <FontAwesomeIcon icon="lock" />
          &nbsp; Clôturer
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AnneeScolaireClotureModal;
